import {
  Entity,
  EntityTypeId,
  EntityTypeKey,
  HomeType,
  ProductCode,
  ProductId,
} from '@/enums';
import { HomeTypeName } from '@/enums/enum/HomeType';
import { ProductName } from '@/enums/enum/ProductName';
import { getRoute } from '@/hooks/useRouteSection';
import { useLocation } from '@reach/router';

export function useProductEntity() {
  const location = useLocation();
  const { entity, productType } = getRoute(location.pathname);

  const getEntityTypeId = () => {
    return (
      {
        [Entity.Insurance]: EntityTypeId.EGIB,
        [Entity.Takaful]: EntityTypeId.EGTB,
      }[entity] || EntityTypeId.EGIB
    );
  };

  const getEntityTypeKey = () => {
    return {
      [Entity.Insurance]: EntityTypeKey.EGIB,
      [Entity.Takaful]: EntityTypeKey.EGTB,
    }[entity];
  };

  const getProductId = () => {
    return {
      [HomeType.Hohh]: {
        [Entity.Insurance]: ProductId.HOHHInsurance,
        [Entity.Takaful]: ProductId.HOHHTakaful,
      },
      [HomeType.MyRumah]: {
        [Entity.Insurance]: ProductId.MyRumahInsurance,
        [Entity.Takaful]: ProductId.MyRumahTakaful,
      },
    }[productType][entity];
  };

  const getProductCode = () => {
    return {
      [HomeType.Hohh]: {
        [Entity.Insurance]: ProductCode.HOHHInsurance,
        [Entity.Takaful]: ProductCode.HOHHTakaful,
      },
      [HomeType.MyRumah]: {
        [Entity.Insurance]: ProductCode.MyRumahInsurance,
        [Entity.Takaful]: ProductCode.MyRumahTakaful,
      },
    }[productType][entity];
  };

  const getProductName = () => {
    return {
      [HomeType.Hohh]: {
        [Entity.Insurance]: ProductName.HOHHInsurance,
        [Entity.Takaful]: ProductName.HOHHTakaful,
      },
      [HomeType.MyRumah]: {
        [Entity.Insurance]: ProductName.MyRumahInsurance,
        [Entity.Takaful]: ProductName.MyRumahTakaful,
      },
    }[productType][entity];
  };

  const getProduct = () => {
    return {
      [HomeType.Hohh]: HomeTypeName.HOHH,
      [HomeType.MyRumah]: HomeTypeName.MyRumah,
    }[productType];
  };

  return {
    getEntityTypeId,
    getEntityTypeKey,
    getProduct,
    getProductId,
    getProductName,
    getProductCode,
  };
}
